/**
 * Womit bedient wird: Maus oder Finger. Entscheidet, welche Steuerung die
 * Ego-Ansicht bekommt und ob Hinweise von Tasten oder vom Tippen sprechen.
 */

/** Ab dieser Breite gilt die Phone-Anordnung (siehe Media Query in tokens.css). */
export const PHONE_BREAKPOINT_PX = 760;

export interface EingabeUmgebung {
  matchMedia?: (query: string) => { matches: boolean };
  maxTouchPoints?: number;
}

function browserUmgebung(): EingabeUmgebung {
  if (typeof window === 'undefined') return {};
  return {
    matchMedia: typeof window.matchMedia === 'function' ? (q) => window.matchMedia(q) : undefined,
    maxTouchPoints: typeof navigator !== 'undefined' ? navigator.maxTouchPoints : undefined,
  };
}

/**
 * Touch-Geraet: der grobe Zeiger ist die Primaerquelle. `maxTouchPoints`
 * zaehlt nur ohne `matchMedia` — ein Laptop mit Touchscreen und Maus meldet
 * Touchpunkte, soll aber Maus-Look und Zeigerfang behalten.
 */
export function istTouchGeraet(umgebung: EingabeUmgebung = browserUmgebung()): boolean {
  if (umgebung.matchMedia) return umgebung.matchMedia('(pointer: coarse)').matches;
  return (umgebung.maxTouchPoints ?? 0) > 0;
}
